module.exports = __webpack_public_path__ + "media/soundtrack.430aaa0f.mp3";